import Dashboard from 'screens/Dashboard/Dashboard';
import ScreenReviewRulesDetails from 'screens/ReviewRules/Details';
// @material-ui/icons
import DashboardIcon from '@material-ui/icons/DashboardOutlined';
import Users from '@material-ui/icons/SupervisorAccountOutlined';
import Verified from '@material-ui/icons/VerifiedUserOutlined';
import Visibility from '@material-ui/icons/VisibilityOutlined';
import List from '@material-ui/icons/ViewListOutlined';
import Person from '@material-ui/icons/PersonOutlined';
import TrackChanges from '@material-ui/icons/TrackChanges';
import Assignment from '@material-ui/icons/Assignment';
import Email from '@material-ui/icons/Email';
import Flag from '@material-ui/icons/Flag';
import Atm from '@material-ui/icons/LocalAtm';
import Assessment from '@material-ui/icons/AssessmentOutlined';
import Payment from '@material-ui/icons/PaymentOutlined';
import Notifications from '@material-ui/icons/Notifications';
import ReportProblem from '@material-ui/icons/ReportProblem';
// our routes
import ScreenPaidAdReviewList from 'screens/PaidAd/Review/List';
import adsRoutes from './ads';
import paidadsRoutes from './paidads';
import expiredAdsRoutes from './expired_ads';
import reviewQueueRoutes from './review_queue';
import reviewReportRoutes from './review_reports';
import reviewRoutes from './reviews';
import usersRoutes from './users';
import permissionsRoutes from './permissions';
import commandsRoutes from './commands';
import sendEmailRoutes from './send_email';
import sendPushNotificationRoutes from './send_push_notification';
import radarRoutes from './radar';
import flaggedAdsRoutes from './flagged_ads';
import processorRuleRoutes from './processor_rules';
import reviewProcessorRuleRoutes from './review_processor_rules';
import reviewProcessorListRoutes from './review_processor_list';
import exchangeRatesRoutes from './exchange_rates';
import currencyFilterRoutes from './currency_filter';
import paymentRoutes from './payment';
import creditRoutes from './credit';
import promotedAds from './promoted_ads';
import promotedAdPackagesRoutes from './promoted_ad_packages';
import creditBundleRoutes from './credit_bundle';
import notificationCategoryRoutes from './notification_category';
import notificationTypeRoutes from './notification_types';
import {
  AD,
  COMMANDS,
  SEND_EMAIL,
  SEND_PUSH_NOTIFICATION,
  CREDIT,
  CURRENCY_FILTER,
  DASHBOARD,
  REVIEW_RULES,
  REVIEW_REPORT,
  EXCHANGE_RATE,
  EXPIRED_AD,
  FLAGGED_ADS,
  PAID_AD,
  PAYMENT,
  PERMISSION,
  PROCESSOR_RULE,
  RADAR,
  REVIEW_PROCESSOR_LIST,
  REVIEW_PROCESSOR_RULE,
  REVIEW_QUEUE,
  REVIEWS,
  USER,
  AGENCY,
  PROMOTED_AD,
  PROMOTED_AD_PACKAGES,
  CREDIT_BUNDLE,
  NOTIFICATION_CATEGORY,
  NOTIFICATION_TYPE,
} from './paths';

const dashRoutes = [
  {
    path: DASHBOARD,
    name: 'dashboard',
    icon: DashboardIcon,
    sidebarShow: true,
    component: Dashboard,
  },
  {
    base: true,
    path: USER.LIST,
    name: 'users',
    icon: Users,
    color: 'primary',
    views: usersRoutes,
    sidebarShow: true,
    allowPermissions: ['list_user', 'list_agency', 'list_user_agency'],
  },
  {
    base: true,
    path: AGENCY.LIST,
    name: 'agencies',
    icon: Person,
    color: 'success',
    views: usersRoutes,
    sidebarShow: true,
    allowPermissions: ['list_user_agency', 'list_ownership_useragency'],
  },
  {
    base: true,
    path: PERMISSION.LIST,
    name: 'permissions',
    icon: Verified,
    color: 'warning',
    views: permissionsRoutes,
    sidebarShow: true,
    allowPermissions: ['list_group'],
  },
  {
    base: true,
    path: AD.LIST,
    name: 'ads',
    icon: List,
    color: 'info',
    views: adsRoutes,
    sidebarShow: true,
    allowPermissions: ['list_ad'],
  },
  {
    base: true,
    path: PAID_AD.LIST,
    name: 'paidads',
    icon: List,
    color: 'rose',
    views: paidadsRoutes,
    sidebarShow: true,
    allowPermissions: ['list_ownership_autopaidad', 'list_autopaidad'],
  },
  {
    base: true,
    path: PROMOTED_AD.LIST,
    name: 'promoted_ads',
    icon: List,
    color: 'rose',
    views: promotedAds,
    sidebarShow: true,
    allowPermissions: ['list_ownership_promotedad', 'list_promotedad'],
  },
  {
    base: true,
    path: PROMOTED_AD_PACKAGES.LIST,
    name: 'packages',
    views: promotedAdPackagesRoutes,
    icon: List,
    sidebarShow: true,
    allowPermissions: ['list_promotedadpackage'],
  },
  {
    base: true,
    path: CREDIT_BUNDLE.LIST,
    name: 'credit_bundle',
    views: creditBundleRoutes,
    icon: List,
    sidebarShow: true,
    allowPermissions: ['list_ownership_creditbundle', 'list_creditbundle'],
  },
  {
    base: true,
    path: EXPIRED_AD.LIST,
    name: 'expired_ads',
    icon: List,
    color: 'info',
    views: expiredAdsRoutes,
    sidebarShow: true,
    allowPermissions: ['list_expiredad'],
  },
  {
    base: true,
    path: EXCHANGE_RATE.LIST,
    name: 'exchange_rates',
    icon: Atm,
    color: 'warning',
    views: exchangeRatesRoutes,
    sidebarShow: true,
    allowPermissions: ['list_exchangerate'],
  },
  {
    base: true,
    path: CURRENCY_FILTER.LIST,
    name: 'currency_filter',
    icon: List,
    color: 'warning',
    views: currencyFilterRoutes,
    sidebarShow: true,
    allowPermissions: ['view_currencyfilter'],
  },
  {
    base: true,
    path: PAID_AD.REPORT.LIST,
    name: 'paidad_report',
    icon: Assessment,
    color: 'primary',
    views: paidadsRoutes,
    sidebarShow: true,
    allowPermissions: ['report_autopaidad', 'report_ownership_autopaidad'],
  },
  {
    // base: true,
    path: PAID_AD.REVIEW.LIST,
    name: 'paidad_review',
    icon: List,
    color: 'primary',
    // views: paidadsRoutes,
    component: ScreenPaidAdReviewList,
    sidebarShow: true,
    allowPermissions: ['list_autopaidad'],
  },
  {
    base: true,
    path: REVIEW_QUEUE.LIST,
    name: 'review_queue',
    icon: Visibility,
    color: 'danger',
    views: reviewQueueRoutes,
    sidebarShow: true,
    allowPermissions: ['list_ad_to_review'],
  },
  {
    base: true,
    path: REVIEWS.LIST,
    name: 'reviews',
    icon: Assignment,
    color: 'primary',
    views: reviewRoutes,
    sidebarShow: true,
    allowPermissions: ['list_review'],
  },
  {
    base: true,
    path: REVIEW_REPORT.LIST,
    name: 'review_reports',
    icon: ReportProblem,
    color: 'danger',
    views: reviewReportRoutes,
    sidebarShow: true,
    allowPermissions: ['reviews.list_reviewreport', 'list_reviewreport'],
  },
  {
    path: REVIEW_RULES.DETAILS,
    name: 'review_rules',
    component: ScreenReviewRulesDetails,
    sidebarShow: false,
  },
  {
    base: true,
    path: FLAGGED_ADS.LIST,
    name: 'flagged_ads',
    icon: Flag,
    color: 'danger',
    views: flaggedAdsRoutes,
    sidebarShow: true,
    allowPermissions: ['view_adflag'],
  },
  {
    base: true,
    path: COMMANDS.LIST,
    name: 'commands',
    icon: List,
    color: 'warning',
    views: commandsRoutes,
    sidebarShow: true,
    allowPermissions: [],
  },
  {
    base: true,
    path: SEND_EMAIL.FORM,
    name: 'send_email',
    icon: Email,
    color: 'warning',
    views: sendEmailRoutes,
    sidebarShow: true,
    allowPermissions: [],
  },
  {
    base: true,
    path: SEND_PUSH_NOTIFICATION.FORM,
    name: 'send_push_notification',
    icon: Notifications,
    color: 'info',
    views: sendPushNotificationRoutes,
    sidebarShow: true,
    allowPermissions: [],
  },
  {
    base: true,
    path: RADAR.LIST,
    name: 'radar',
    views: radarRoutes,
    icon: TrackChanges,
    sidebarShow: true,
    allowPermissions: ['view_processorlistitem'],
  },
  {
    base: true,
    path: REVIEW_PROCESSOR_LIST.LIST,
    name: 'review_processor_list',
    views: reviewProcessorListRoutes,
    icon: TrackChanges,
    sidebarShow: true,
    allowPermissions: ['view_processorlistitem'],
  },
  {
    base: true,
    path: PROCESSOR_RULE.LIST,
    name: 'processor_rules',
    views: processorRuleRoutes,
    icon: Assignment,
    sidebarShow: true,
    allowPermissions: ['list_processorrule'],
  },
  {
    base: true,
    path: REVIEW_PROCESSOR_RULE.LIST,
    name: 'review_processor_rules',
    views: reviewProcessorRuleRoutes,
    icon: Assignment,
    sidebarShow: true,
    allowPermissions: ['list_processorrule'],
  },
  {
    base: true,
    path: PAYMENT.LIST,
    name: 'payment',
    views: paymentRoutes,
    icon: Payment,
    sidebarShow: true,
    allowPermissions: ['list_payment'],
  },
  {
    base: true,
    path: CREDIT.LIST,
    name: 'credit',
    views: creditRoutes,
    icon: Payment,
    sidebarShow: true,
    allowPermissions: [
      'list_credittransaction',
      'list_ownership_credittransaction',
    ],
  },
  {
    base: true,
    path: NOTIFICATION_CATEGORY.LIST,
    name: 'notification_categories',
    views: notificationCategoryRoutes,
    icon: Notifications,
    sidebarShow: true,
    allowPermissions: ['list_notificationcategory'],
  },
  {
    base: true,
    path: NOTIFICATION_TYPE.LIST,
    name: 'notification_types',
    views: notificationTypeRoutes,
    icon: Notifications,
    sidebarShow: true,
    allowPermissions: ['list_notificationtype'],
  },
];
export default dashRoutes;
